<template>
	<!-- 固定资产表 -->
	<div>
		<div v-if="!editShow">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">固定资产表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
					<el-row>

						<!-- 右侧列表 -->
						<el-col :span="24">
							<el-row style="padding-left: 2%; padding-top: 40px;">
								<el-col :span="4">
									<span>名称 </span>
									<el-input v-model="condition.name" placeholder="请输入内容"
										style="width:180px;margin-left:10px"></el-input>
								</el-col>

								<el-col :span="6">
									<el-button type="goon" @click="Find">查询</el-button>
									<el-button type="goon" @click="AddFrom">新增</el-button>
								</el-col>
							</el-row>

							<!-- 表格 -->
							<div style="margin:30px 3% 0 3%">
								<el-row>
									<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" height="574px"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										tooltip-effect="dark" style="width: 100%"
										@selection-change="handleSelectionChange">
										<el-table-column type="selection" width="55">
										</el-table-column>
										<el-table-column label="序号" width="80">
											<template slot-scope="scope_1">
												{{scope_1.$index + 1}}
											</template>
										</el-table-column>
										<el-table-column prop="name" align="center" label="名称">
										</el-table-column>
										<el-table-column prop="brand" align="center" label="品牌">
										</el-table-column>
										<el-table-column prop="specification_model" align="center" label="规格型号">
										</el-table-column>
										<el-table-column prop="basic_unit" align="center" label="基本单位">
										</el-table-column>
										<el-table-column prop="unit_price" align="center" label="单价">
										</el-table-column>
										<el-table-column prop="notes" align="center" label="备注">
										</el-table-column>
										<el-table-column align="center" label="操作">
											<template slot-scope="scope">
												<img src="../../assets/编辑.png" @click="UpdateFrom(scope.row)">
												<img src="../../assets/删除.png" @click="Del(scope.row.id)"
													style="margin-left: 10px" />
												<img src="../../assets/详情.png" @click="Edit(scope.row)"
													style="margin-left: 10px" />
											</template>
										</el-table-column>
									</el-table>
								</el-row>

								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-row>

			<!-- 详情 -->
			<div>
				<el-dialog :title="from.id == null || from.id == '' ? '添加固定资产' : '修改固定资产'" :visible.sync="dialogVisible"
					width="30%" :close-on-click-modal="false" :center="true">

					<el-form :model="from" :rules="rules" ref="from" style="padding: 0 8% 0 0;" label-width="80px">
						<el-form-item label="名称" prop="name">
							<el-input v-model="from.name" placeholder="请输入名称" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="品牌" prop="brand">
							<el-input v-model="from.brand" placeholder="请输入品牌" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="规格型号" prop="specification_model">
							<el-input v-model="from.specification_model" placeholder="请输入规格型号" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="基本单位" prop="basic_unit">
							<el-input v-model="from.basic_unit" placeholder="请输入基本单位" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="单价" prop="unit_price">
							<el-input v-model="from.unit_price" placeholder="请输入单价" style="width: 100%;" type="number"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="from.notes" placeholder="请输入备注" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item style="text-align: center;">
							<el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
								style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
							<el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
								style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
						</el-form-item>
					</el-form>
				</el-dialog>
			</div>
		</div>
		<edit v-if="editShow" @return="Return" :List="List"></edit>
	</div>

</template>

<script>
	import edit from "./editfix.vue";
	export default {
		components: {
			edit: edit
		},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				List:[],

				//条件
				condition: {
					name: "",
				},

				//复选框ids
				ids: [],

				//页面相关
				dialogVisible: false,
				editShow: false,

				//表单数据
				from: {
					id: "",
					name: "",
					brand: '',
					specification_model: '',
					basic_unit: '',
					unit_price:'',
					notes: '',
				},

				//表单验证
				rules: {
					name: [{
						required: true,
						message: '请输入名称！',
						trigger: 'blur'
					}],
					brand: [{
						required: true,
						message: '请输入品牌！',
						trigger: 'blur'
					}],
					specification_model: [{
						required: true,
						message: '请输入规格型号！',
						trigger: 'blur'
					}],
					basic_unit: [{
						required: true,
						message: '请输入基本单位！',
						trigger: 'blur'
					}],
					unit_price: [{
						required: true,
						message: '请输入单价！',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			// 全选
			handleSelectionChange(val) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				})
			},
			//添加页面
			AddFrom() {
				this.from = {};
				this.dialogVisible = true;
			},
			//添加操作
			Add() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {
						var url = "sysCityAsset/add";
						var data = await this.$globals.AxiosPost(url, this.from);
						if (data === "-2000") {
							this.$message.error("服务器未响应！请稍后重试");
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.dialogVisible = false;
								this.from = {};
								this.Find();
							} else {
								this.$message.warning(data);
							}
						}
					}
				});
			},
			//编辑页面
			UpdateFrom(e) {
				this.from = e;
				this.dialogVisible = true;
			},
			//编辑操作
			Update() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {
						var url = "sysCityAsset/update";
						var data = await this.$globals.AxiosPost(url, this.from);
						if (data === "-2000") {
							this.$message.error("服务器未响应！请稍后重试");
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.dialogVisible = false;
								this.from = {};
								this.Find();
							} else {
								this.$message.warning(data);
							}
						}
					}
				});
			},
			Edit(e) {
				this.List = e;
				this.editShow = true;
			},
			Return() {
				this.editShow = false;
				this.Find();
			},
			//删除
			async Del(e) {
				var url = "sysCityAsset/del";
				var record = {
					ids: [e]
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.dialogVisible = false;
						this.from = {};
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var url = "sysCityAsset/getList";
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					name: this.condition.name
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
			},
		},
		created() {
			this.Find();
		}
	}
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006E4B;
		color: #fff;
	}

	.el-button--goon {
		color: #FFF;
		background-color: #006E4B;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}
</style>



// WEBPACK FOOTER //
// fixedassets.vue?3decd5f0